import type { JSX } from "react";

import { GuideCostTable } from "../../GuideDataBlocks";
import type { SectionRenderInput } from "./types";

/**
 * WHAT THINGS COST — the city's scraped reading as the numbered panels the guide
 * prints, with the group headings and both figures coming from the reading
 * itself.
 *
 * A city with no reading has nothing to print, so the section renders nothing;
 * the payload's own `rendered` flag is what decides whether it is in the
 * document.
 */
export function CostSection({ page }: SectionRenderInput): JSX.Element | null {
  const cost = page.live?.costOfLiving;
  if (!cost) return null;
  return <GuideCostTable cost={cost} />;
}
